<template>
<div v-if="loggedRoleType!=='user'" class="sidebar z-10" data-color="white" data-background-color="white" data-image="../../static/img/sidebar-1.jpg">
  <div class="sidebar-wrapper">
    <div class="logged-role">
      <div class="info">
        <router-link :to="'/'+ loggedRoleType + 's/account'" >
          <p class="role-name">{{ username }}</p>
        </router-link>
      </div>
      <div class="photo grey-bg" :class="{ 'size-md-bg': img.indexOf('./static/img/shop.svg') !== -1 }" :style="{ 'background-image': 'url(' + img + ')' }">
        <router-link :to="'/'+ loggedRoleType + 's/account'" >
        </router-link>
      </div>
    </div>
    <nav-list :gradient="gradientSwitcher(loggedRoleType)" :navItems="[{ path: '/'+loggedRoleType+'s/account', icon: 'icon-merchant_profile', label_key: profileLabel}]" />
    <nav-list :gradient="gradientSwitcher(loggedRoleType)" class="border-top" :navItems="navigationRoutes" :hasLogout="true" />
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import routesConfig from '@/config/navigation'
import * as _ from 'lodash'
import NavList from '@/components/shared/NavList'
import gradiendSwitcher from '@/mixins/GradientSwitcher'

export default {
  name: 'sidebar',
  components: {
    NavList
  },
  mixins: [gradiendSwitcher],
  data() {
    return {}
  },
  methods: {
    ...mapMutations({
      goTo: 'goTo',
      back: 'back',
      setMerchantIsLogged: 'setMerchantIsLogged'
    })
  },
  computed: {
    ...mapState({
      donation: state =>
        (state.merchant.donation * state.transaction.amount / 100).toFixed(2) + state.transaction.currency,
      username: state => {
        if (state.user.loggedRole.type === 'user') return state.user.firstName + ' ' + state.user.lastName
        else {
          let role = state.user.loggedRole
          if (role.type === 'merchant') {
            return role.merchant.name
          } else if (role.type === 'npo') {
            return role.npo.name
          }
        }
      },
      loggedRoleType: state => (state.user.loggedRole ? state.user.loggedRole.type : 'user'),
      loggedRole: state =>
        state.user.loggedRole && state.user.loggedRole.type !== 'user' ? state.user.loggedRole : state.user,
      currentPath: state => state.currentPath,
      route: state => state.route,
      navigationRoutes: state => {
        let paths = []

        if (state.user.loggedRole) {
          state.user.loggedRole.accessLevels.map(accessLevel => {
            paths = _.unionBy(routesConfig[accessLevel], paths, 'path')
          })
        }
        return _.orderBy(paths, 'order')
      }
    }),
    profileLabel: function(state) {
      return this.loggedRoleType + '_profile'
    },
    img: function(state) {
      switch (this.loggedRoleType) {
        case 'merchant':
          return this.loggedRole.merchant.img || './static/img/shop.svg'
        case 'npo':
          return this.loggedRole.npo.img || './static/img/npo.svg'
        case 'user':
          return this.user.img || './static/img/profile_icon.svg'
        default:
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/config.scss';

.sidebar {
  margin-top: $topbarHeight;
  @include shadow();
}

.sidebar .logged-role {
  margin: 20px auto 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-left: 29px;
  padding-right: $primaryDistance;
}

.sidebar .info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.role-name {
  color: $black;
  font-weight: bold;
  @include bigFontSize();
  @include primaryFont();
  max-width: 170px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.caret {
  color: $azure;
}

.credits {
  color: $azure;
  text-decoration: underline;
  font-weight: bold;
  @include normalFontSize();
}

.animation,
.animation-transition-general,
.hide-sidebar .sidebar,
.hide-sidebar.sidebar-mini .sidebar,
.lock-page .card-profile,
.login-page .card-login,
.sidebar .logo .logo-normal,
.sidebar .logo .simple-text,
.sidebar .logged-role .photo,
.sidebar .logged-role a {
  transition: all 0.3s linear;
}

.sidebar .logged-role .photo {
  width: 33px;
  height: 33px;
  overflow: hidden;
  border-radius: 50%;
  z-index: 5;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0 rgba(0, 0, 0, 0.12),
    0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

.sidebar .logged-role .photo img {
  width: 100%;
}

.sidebar .logged-role a {
  display: block;
  white-space: nowrap;
  color: #202020;
}

.sidebar .border-top:before {
  content: '';
  position: relative;
  width: calc(100% - 34px);
  bottom: 9px;
  left: $primaryDistance;
  height: 1px;
  background-color: $dividerGrey;
}

.sidebar .sidebar-background:after {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  content: '';
  display: block;
  background: $white;
  opacity: 0.93;
}

.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  height: calc(100vh - 45px);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SideBar.vue